import { DefaultService } from '@/services/DefaultService';

export default class MotivoFotoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    save(motivofoto) {
        return this._http.post(`${this._env}/promotor/motivofoto`, motivofoto, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    find(id) {
        return this._http.get(`${this._env}/promotor/motivofoto/${id}.json`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    delete(id) {
        return this._http.delete(`${this._env}/promotor/motivofoto/${id}`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    findAll(column, order, page = 0, limit = 50, situacao = 2, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/promotor/motivofoto.json?column=${column}&order=${order}&page=${page}&limit=${limit}&situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllCombo(...params) {
        return this._http
            .get(
                encodeURI(`${this._env}/promotor/getcombo/reasonphoto.json?param=${params}`),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    updateSituacao(motivofoto) {
        return this._http
            .post(`${this._env}/promotor/motivofoto/updatesituacao`, motivofoto, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
